<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-project-lead-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Project Lead
            </h4>
          </div>

          <div class="modal-body">
            <SelectFormGroup
                v-model="data.status"
                name="status"
                label="Status"
                :error="(errors.status || [])[0]"
                :options="[{value: 'new', label: 'New'}, {value: 'active', label: 'Active'}, {value: 'declined', label: 'Declined'}, {value: 'sale', label: 'Sale'}]"
            />

            <SelectFormGroup
                v-model="data.user_id"
                name="user_id"
                label="User"
                :error="getError('user_id')"
                :options="userOptions"
                :nullable="true"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: {SelectFormGroup},

  mixins: [Errors],

  props: {
    projectLead: {
      required: true
    },

    users: {
      required: true
    }
  },

  data() {
    return {
      data: {},

      loading: true,
    }
  },

  mounted() {
    this.listenForClose()
  },

  watch: {
    projectLead() {
      this.data = {...this.projectLead.attributes}
    }
  },

  computed: {
    userOptions() {
      return this.users.map(user => ({value: user.id, label: user.attributes.full_name}))
    },
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/project-leads/' + this.projectLead.id, this.data)
          .then(response => {
            notify.success('The project lead was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {...this.projectLead.attributes}
    }
  }
}
</script>
